export const style = {
  Typography: {
    variant: 'body1',
    sx: {
      color: 'action.active',
    },
  },
} as const;
